module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    class: this.currentResource,
    attrs: {
      "id": "lower-body"
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "resources"
    }
  }, [_c('div', {
    staticClass: "pure-g"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-lg-1-2"
  }, [_c('section', {
    staticClass: "feature"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sectionText"
  }, [_c('h1', [_vm._v("Support Running Year")]), _vm._v(" "), _c('p', [_vm._v("Donate any amount to help us get more people fit, healthy and running in " + _vm._s(this.sharedState.year))]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _vm._v(" "), _c('section', {
    staticClass: "feature"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sectionText"
  }, [_c('h1', [_vm._v("Running resources"), (this.currentResource) ? _c('span', [_vm._v(" › " + _vm._s(this.getResourceData('name')))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("We've curated a list of " + _vm._s(this.getResourceCount()) + " resources for runners, to get you on the right track and help you run better."), _c('br'), (this.sharedState.pledgeCompleted) ? _c('span', [_vm._v("Click on one of the categories below to get started..")]) : _c('span', [_vm._v("To access them, you need to pledge to run first.")])])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "tag": "ul",
      "name": "slide",
      "id": "resourceMosaic"
    }
  }, [(this.currentResource) ? _c('li', {
    key: "back",
    on: {
      "click": function($event) {
        _vm.setCurrentResource(false)
      }
    }
  }, [_c('div', {
    staticClass: "resource"
  }, [_c('div', {
    staticClass: "card goBackCard"
  }, [_c('h2', [_vm._v("View the whole collection of running resources")])]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_vm._v("‹ Go Back")])])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._l((_vm.resources), function(category, key) {
    return [(_vm.noResourceSelected()) ? _c('li', {
      key: category.name,
      on: {
        "click": function($event) {
          _vm.setCurrentResource(key)
        }
      }
    }, [_c('resource-collection', {
      attrs: {
        "cardClass": key,
        "totalItems": category.resources.length,
        "isUnlocked": _vm.isPledgeCompleted
      }
    }, [_c('h1', {
      slot: "title"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('p', {
      slot: "description"
    }, [_vm._v(_vm._s(category.description))])])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._l((category.resources), function(resource) {
      return (_vm.isCurrentResource(key)) ? _c('li', {
        key: resource.name
      }, [_c('a', {
        staticClass: "resourceLink",
        attrs: {
          "href": resource.website,
          "title": resource.name,
          "target": "new"
        }
      }, [_c('resource', {
        attrs: {
          "website": resource.website,
          "logo": resource.logo
        }
      }, [_c('h1', {
        slot: "title"
      }, [_vm._v(_vm._s(resource.name))]), _vm._v(" "), _c('p', {
        slot: "description"
      }, [_vm._v(_vm._s(resource.description))])])])]) : _vm._e()
    }), _vm._v(" ")]
  }), _vm._v(" ")], true)]), _vm._v(" "), (this.sharedState.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-lg-1-2"
  }, [_c('section', {
    staticClass: "feature"
  }, [_c('div', {
    staticClass: "sectionIcon"
  }, [_c('div', {
    staticClass: "icon-bg"
  }, [_c('label', {
    staticClass: "icon-reminder"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sectionText"
  }, [_c('h1', [_vm._v("Running reminders")]), _vm._v(" "), _c('p', [_vm._v("By pledging to run you’ll receive occasional emails encouraging you to go out for a jog.\n")]), _c('div', {
    staticClass: "small"
  }, [_vm._v("This is a free service and you can unsubscribe at any time with a single click.")]), _c('p')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "sectionIcon"
  }, [_c('div', {
    staticClass: "icon-bg"
  }, [_c('label', {
    staticClass: "icon-donate"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "MMFWNSKDZVWUA"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "border": "0",
      "name": "submit",
      "value": "Donate with PayPal",
      "id": "donateButton"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_GB/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "sectionIcon"
  }, [_c('div', {
    staticClass: "icon-bg"
  }, [_c('label', {
    staticClass: "icon-resources"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb53e0da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources.vue
// module id = 108
// module chunks = 2